import React from "react";
import PropTypes from 'prop-types';
import RenderComponentProto from "../../render-component-proto";

import StringInListWithPopover from "./list/formula-list-with-popover";

export default class FormulaFieldProto extends RenderComponentProto {

    static props = {
        id: PropTypes.string.isRequired, // CF id
        renderMode: PropTypes.oneOf(['list','view','edit','form-new']).isRequired,
        item: PropTypes.object,

        canEdit: PropTypes.bool,

        onTogglePopover: PropTypes.func,
        onChange: PropTypes.func,
    };

    static defaultProps = {
        canEdit: false,
    };

    render() {
        let res;
        switch (this.props.renderMode) {
            case 'list':
            case 'view':
            case 'edit':
            case 'form-new':
            default: res = <StringInListWithPopover {...this.props} className={Classes('gd-field-formula',this.props.renderMode)}/>; break;
        }

        return res;
    }
}